module.exports = __webpack_public_path__ + "img/slide_4.97de702a.webp";